export default {
  en: {
    app: {
      getAndroidApp: 'Get pharma.sensor for Android.',
      getiOSApp: 'Get pharma.sensor for iOS.',
      loading: 'Loading...'
    },
    logIn: {
      welcome: 'Welcome',
      passwordReset: 'Forgot password?',
      loginError:
        'Wrong username or password. Please try again or get a new Password.',
      cookieHint:
        'This website uses cookies to support a comfortable user experience. For more information see our privacy policy.',
      cookieHintButton: 'I understand',
      changePasswordAfterFirstLogin:
        'Please change your initial passwort, before proceeding with the application.',
      logOut: 'Log out',
      or: 'or'
    },
    loginForm: {
      username: 'Username',
      password: 'Password',
      showPassword: 'Show password',
      loginButton: 'Log in'
    },
    navbar: {
      logout: 'Log out',
      settings: 'Settings',
      check: 'Drug check',
      mydna: 'My DNA analysis',
      report: 'Clinical report',
      drugs: 'Active ingredients',
      genes: 'Genes',
      results: 'Results',
      favorites: 'Favorites',
      help: 'Support',
      more: 'More',
      userInfo: 'logged in as',
      patientInfo: 'selected patient:',
      noSelection: 'none',
      loading: 'Loading...'
    },
    settings: {
      loading: 'Settings changes are being saved...'
    },
    passwordForm: {
      header: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      newPasswordConfirm: 'Confirm new password',
      confirmPasswordError:
        'The values entered for the new password must be identical.',
      submitButton: 'Change password',
      changeError: `Your current password is missing or incorrect. It's required to change the password.`,
      success: 'Your password was successfully changed!',
      hint: 'For security reasons we recommend to change your password.',
      showPassword: 'Show password'
    },
    emailForm: {
      reasonHeader: 'Enter email address',
      reason1: 'to restore your password,\nin case you forget it',
      reason2:
        'for notifications in case of updates\ne.g. of recommendations for drug therapy',
      email: 'Enter email address',
      emailConfirm: 'Confirm email address',
      password: 'Enter password',
      currentPassword: 'your password',
      submitButton: 'Save email address',
      error: 'Your email address could not be changed. Please try again.',
      success: 'Email address changed successfully!',
      confirmEmailError: 'The email confirmation is incorrect.',
      skipButton: 'Skip'
    },
    requestPasswordResetForm: {
      header: 'Password reset',
      description:
        'Enter your username and we will send you an e-mail with further instructions.',
      username: 'Enter username',
      usernameConfirmation: 'Confirm username',
      submitButton: 'Submit form',
      cancel: 'Cancel and go back to login',
      error:
        'The entered username is wrong or the user does not have an email address assigned',
      success: 'Further instructions have been sent to your email address',
      confirmationError:
        'The entered values are not identical. Please try again'
    },
    passwordResetForm: {
      header: 'Password reset',
      newPassword: 'Enter New password',
      newPasswordConfirmation: 'Confirm new password',
      submitButton: 'Save password',
      success: 'Your password was reseted successfully',
      confirmationError:
        'The enetered values are not identical, please try again',
      error:
        'There was an error while processing your request, please try again',
      redirect: 'Go to login'
    },
    languageForm: {
      header: 'Preferred language',
      error: 'Language could not be changed. Please try again.',
      de: 'German',
      en: 'English'
    },
    footer: {
      imprint: 'Imprint',
      terms: 'Terms and conditions',
      policy: 'Privacy policy'
    },
    search: {
      intro:
        'search for drugs and active ingredients to get personal recommendations',
      inputText:
        'type in drugs, active ingredients or ‚Pharmazentralnummer‘ (PZN code)',
      most_common_search: 'most common searches for active ingredients:',
      autocomplete_no_results: 'No results found',
      search_param: 'You searched for:',
      search_result_description:
        'Your search delivered results for the following active ingredients:',
      favorite_button_add: 'Add to favorites',
      favorite_button_remove: 'Remove from favorites',
      search_results_empty: `For this active ingredient, there are currently no treatment recommendations based on DNA variants.`,
      fetching: 'Search is being processed, please wait...',
      legend: {
        button: "What's the meaning of the symbols?",
        text: {
          good: 'Your DNA variants do not affect the effect of this substance.',
          alert:
            'Your DNA variants are relevant to the effect of this substance.\n Please refer to the recommendations.'
        },
        close: 'Close'
      },
      sections: {
        recommendation: 'recommendation',
        gene_info: 'gene',
        background_info: 'scientific background',
        references: 'literature'
      },
      no_info: 'This feature will be available soon.',
      clear_search: 'Clear search',
      active_ingredient_name: 'active ingredient',
      drug_name: 'drug',
      gene: 'Gene',
      pzn: 'PZN'
    },
    help: {
      text: `Questions? Contact us:`,
      tel: 'tel',
      fax: 'fax'
    },
    searchResultItem: {
      myResult: 'my DNA-variant',
      viewMore: 'view more',
      viewLess: 'view less'
    },
    tutorial: {
      openModal: 'Tutorial pharmacogenetics',
      title: 'Tutorial',
      closeButton: 'Cancel',
      prev: 'Previous',
      next: 'Next',
      slide1: {
        title: 'Overview: genes, DNA variants, proteins and drug efficacy',
        subTitle: 'Genes',
        list:
          'are DNA sections contain the blueprint for making proteins'
      },
      slide2: {
        title: 'How a drug travels through our body',
        list:
          'certain proteins are important for drugs to be effective'
      },
      slide3: {
        title: 'DNA variants',
        list:
          'individual DNA variants in genes influence the function of these proteins'
      },
      slide4: {
        title: 'Effects of DNA variants on drugs',
        list:
          'therefore, the efficacy of drugs may be different for every person\nthey may be toxic, too strong, or may not work at all'
      }
    },
    report: {
      personalizeButton: 'Create report',
      reportInfo: `
      <p>Please fill the opening form with your personal information before printing. By doing so a doctor can use the available recommendations for a clinical decision.</p>
      <p>
      The report is targeted exclusively to the person, whose analysis results are shown in this user account.
      </p>`,
      reportIsGenerating: `Your report is being generated and will be available shortly.
      Please note that the PDF will be ready for download for 30 seconds.
      After that the document and your personal data will be disposed.`,
      noReportFound: '<p>There are no reports available</p>',
      noPersonalizationFields:
        'An error has occured. Please contact the customer support.',
      printJobStatusPending: 'Report is being created...',
      printJobStatusReady: 'Report created successfully.',
      printJobStatusError:
        'Error while creating report. Please try again later.',
      printJobStatusExpired: `Timeout during order processing. For protection of data privacy,
        personalized reports are deleted after 30 seconds. Please, generate a new report.`,
      sendButton: 'Send',
      downloadButton: 'Download here'
    },
    favorites: {
      loadingMessage: 'Loading your list of favorites',
      empty: "You didn't save any favorite yet",
      editButton: 'Edit',
      finishButton: 'Finish editing',
      drugs: 'Active ingredients / medicaments',
      genes: 'Genes',
      actions: {
        remove: {
          label: 'Remove',
          errorMessage: 'Favorite could not be removed, try again later.'
        }
      }
    },
    recommendation: {
      suggestionText:
        'based on your search, the following information for the active ingredient ‚<span class="emphasized">{activeIngredient}</span>‘ were found',
      notice:
        'This report does not replace a decision made in cooperation with a physician or genetic counselor.\n To avoid serious health risks, change of medicinal therapy should only be done under medical supervision.'
    },
    myDna: {
      noContent: 'No content available.',
      descriptions: {
        genes:
          'Genes in which personal DNA variants were found and their role in drug therapies.',
        drugs: 'Active ingredients with personal dosis recommendations.',
        results: 'All results from my laboratory analysis.'
      },
      loadingMessage: 'Data is loading'
    },
    information: {
      loadingMessage: 'Data is loading'
    },
    feedback: {
      openModalButton: 'Send us feedback',
      title: 'Feedback about the app',
      rating: {
        awesome: 'Awesome!',
        good: 'Good',
        meh: 'Meh!',
        bad: 'Bad',
        horrible: 'Horrible!'
      },
      rateThisPage: 'Rate this page',
      whatDoYouLike: 'What do you like?',
      whatNeedsToBeImproved: 'What needs to be improved?',
      submitButton: 'Submit',
      cancelButton: 'Close',
      statusError: {
        requiredFields:
          'The form could not be sent because some required fields are missing.',
        requestError: 'An error occurred! Please try again later.'
      },
      statusSuccess: 'Thanks for your Feedback!',
      requiredField: 'Required field'
    },
    patientScopeSwitcher: {
      inputText: 'Patienten ID'
    }
  },
  de: {
    app: {
      getAndroidApp: 'Hol dir pharma.sensor für Android.',
      getiOSApp: 'Hol dir pharma.sensor für iOS.',
      loading: 'Inhalte werden geladen...'
    },
    logIn: {
      welcome: 'Willkommen',
      passwordReset: 'Passwort vergessen?',
      loginError:
        'Nutzername oder Passwort falsch. Bitte versuche es noch einmal oder fordere ein neues Passwort an.',
      cookieHint:
        'Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Durch die weitere Nutzung der Webseite stimmen Sie der Verwendung von Cookies zu.',
      cookieHintButton: 'Ich habe verstanden',
      changePasswordAfterFirstLogin:
        'Bitte ändere dein ursprüngliches Passwort, bevor du mit der Anwendung fortfährst.',
      logOut: 'Ausloggen',
      or: 'oder'
    },
    loginForm: {
      username: 'Benutzername',
      password: 'Passwort',
      loginButton: 'Anmelden',
      showPassword: 'Passwort einblenden'
    },
    navbar: {
      logout: 'Abmelden',
      settings: 'Einstellungen',
      check: 'Medikamenten-Check',
      mydna: 'Meine DNA-Analysen',
      report: 'Befundbericht',
      drugs: 'Wirkstoffe',
      genes: 'Gene',
      results: 'Ergebnisse',
      favorites: 'Favoriten',
      help: 'Support',
      more: 'Mehr',
      userInfo: 'angemeldet als',
      patientInfo: 'ausgewählter Patient:',
      noSelection: 'keine/r',
      loading: 'Lädt...'
    },
    settings: {
      loading: 'Einstellungen werden gespeichert...'
    },
    passwordForm: {
      header: 'Passwort ändern',
      currentPassword: 'Aktuelles Passwort eingeben',
      newPassword: 'Neues Passwort eingeben',
      newPasswordConfirm: 'Neues Passwort bestätigen',
      confirmPasswordError:
        'Die Eingaben für das neue Passwort stimmen nicht überein.',
      submitButton: 'Passwort ändern',
      changeError:
        'Dein aktuelles Passwort ist leer oder ungültig. Die Angabe ist notwendig, um das Passwort zu ändern.',
      success: 'Dein Passwort wurde erfolgreich geändert.',
      hint: 'Aus Sicherheitsgründen empfehlen wir dein Passwort zu ändern.',
      showPassword: 'Passwort einblenden'
    },
    passwordResetForm: {
      header: 'Wiederherstellung deines Passwortes',
      newPassword: 'Neues Passwort eingeben',
      newPasswordConfirmation: 'Neues Passwort bestätigen',
      submitButton: 'Neues Passwort speichern',
      success: 'Dein Passwort wurde erfolgreich geändert',
      confirmationError:
        'Die eingegebene Werte stimmen nicht überein, bitte versuche es erneut',
      error:
        'Es gab einen Fehler bei der Verarbeitung deiner Daten, bitte versuche es erneut',
      redirect: 'Hier geht es zum Login'
    },
    emailForm: {
      reasonHeader: 'E-Mail-Adresse eingeben',
      reason1:
        'um dein Passwort wiederherzustellen,\nfalls du es vergessen hast',
      reason2:
        'für Benachrichtigungen bei Aktualisierungen,\n z.B. von Empfehlungen für Arzneimitteltherapie',
      header: 'E-Mail-Adresse eingeben',
      email: 'E-Mail-Adresse eingeben',
      emailConfirm: 'E-Mail-Adresse bestätigen',
      password: 'Passwort eingeben',
      submitButton: 'E-Mail-Adresse speichern',
      error:
        'Deine E-Mail-Adresse konnte nicht geändert werden. Bitte versuche es erneut.',
      success: 'E-Mail-Adresse erfolgreich geändert!',
      confirmEmailError:
        'Die E-Mail-Adresse und die Bestätigung stimmen nicht überein',
      skipButton: 'Überspringen'
    },
    requestPasswordResetForm: {
      header: 'Passwort zurücksetzen',
      description:
        'Gib deinen Nutzernamen ein und wir werden dir eine E-Mail mit weiteren Anweisungen senden.',
      username: 'Benutzername eingeben',
      usernameConfirmation: 'Benutzername bestätigen',
      submitButton: 'Absenden',
      cancel: 'Abbrechen und zurück zum Login',
      error:
        'Der eingegebene Nutzer existiert nicht oder er hat keine zugewiesene E-Mail-Adresse.',
      success:
        'Wir haben weitere Anweisungen an deine E-Mail-Adresse gesendet.',
      confirmationError:
        'Die Eingaben stimmen nicht überein. Bitte versuche es erneut.'
    },
    languageForm: {
      header: 'Sprache',
      error: 'Sprache konnte nicht geändert werden. Bitte versuche es erneut.',
      de: 'Deutsch',
      en: 'Englisch'
    },
    footer: {
      imprint: 'Impressum',
      terms: 'AGB',
      policy: 'Datenschutzerklärung'
    },
    search: {
      intro:
        'Suche nach Medikamenten und Wirkstoffen,\n um persönliche Empfehlungen zu erhalten.',
      inputText:
        'Medikament, Wirkstoff oder Pharmazentralnummer (PZN) eingeben',
      most_common_search: 'häufig gesuchte Wirkstoffe:',
      autocomplete_no_results: 'Keine Ergebnisse gefunden',
      search_param: 'Du hast folgendes gesucht:',
      search_result_description:
        'Deine Suche lieferte Treffer für folgende Wirkstoffe:',
      favorite_button_add: 'Zu Favoriten hinzufügen',
      favorite_button_remove: 'Aus Favoriten entfernen',
      search_results_empty: `Für diesen Wirkstoff liegen aktuell keine Therapieempfehlungen vor, die auf Kenntnissen von DNA-Varianten basieren.`,
      fetching: 'Ergebnisse werden geladen, bitte warten...',
      legend: {
        button: 'Was bedeuten die Symbole?',
        text: {
          good:
            'Deine DNA-Varianten beeinflussen die Wirkung dieser Substanz nicht.',
          alert:
            'Für die Wirkung dieser Substanz sind deine DNA-Varianten relevant.\n Beachte die Empfehlungen hierzu.'
        },
        close: 'Schließen'
      },
      sections: {
        recommendation: 'Empfehlung',
        gene_info: 'Gen',
        background_info: 'Fachinformation',
        references: 'Literatur'
      },
      no_info: 'Diese Funktion steht demnächst zur Verfügung.',
      clear_search: 'Suche zurücksetzen',
      active_ingredient_name: 'Wirkstoff',
      drug_name: 'Medikament',
      gene: 'Gen',
      pzn: 'PZN'
    },
    help: {
      text: 'Noch Fragen? So sind wir erreichbar:',
      tel: 'Tel.',
      fax: 'Fax.'
    },
    searchResultItem: {
      myResult: 'meine DNA-Variante',
      viewMore: 'mehr erfahren',
      viewLess: 'schließen'
    },
    tutorial: {
      openModal: 'Tutorial Pharmakogenetik',
      title: 'Tutorial',
      closeButton: 'Schließen',
      prev: 'Zurück',
      next: 'Weiter',
      slide1: {
        title:
          'Überblick: Gene, DNA-Varianten, Proteine und die Wirkung von Medikamenten',
        subTitle: 'Gene',
        list:
          'sind Abschnitte der DNA \nenthalten die Bauanleitung zur Herstellung von Proteinen'
      },
      slide2: {
        title: 'Der Weg eines Medikamentes durch den Körper',
        list:
          'bestimmte Proteine sind wichtig für die Wirkung von Medikamenten'
      },
      slide3: {
        title: 'DNA-Varianten',
        list:
          'individuelle DNA-Varianten in Genen beeinflussen die Funktion dieser Proteine'
      },
      slide4: {
        title: 'Auswirkungen von DNA-Varianten auf Medikamente',
        list:
          'somit können Medikamente bei verschiedenen Menschen unterschiedliche Effekte haben\nsie können toxisch, zu stark oder gar nicht wirken'
      }
    },
    report: {
      personalizeButton: 'Bericht erstellen',
      reportInfo: `<p>
        Damit ein Arzt deinen Befundbericht mit den darin enthaltenen Empfehlungen für klinische Entscheidungen verwenden kann, sind vor dem Ausdrucken in das erscheinende Formular persönliche Angaben einzugeben.</p>
        <p>Der Bericht ist nur für die Person autorisiert, deren Analyseergebnisse in diesem Account berichtet werden.</p>`,
      printJobStatusPending: 'Befundbericht wird erstellt...',
      printJobStatusReady: 'Befundbericht steht zur Verfügung.',
      printJobStatusError:
        'Befundbericht konnte nicht erstellt werden. Bitte versuche es zu einem späteren Zeitpunkt noch einmal.',
      printJobStatusExpired:
        'Zeitüberschreibung bei der Verarbeitung des Auftrages. Aus Gründen des Datenschutzes werden personalisierte Befundberichte nach 30 Sekunden gelöscht. Bitte erstelle einen neuen Befundbericht.',
      reportIsGenerating: `Dein Befundbericht wird erstellt und steht in Kürze bereit. Bitte beachte,
      dass das PDF dann für 30 Sekunden zum Download verfügbar ist.
      Nach Ablauf dieser Zeit werden das Dokument sowie deine persönlichen Daten gelöscht.`,
      noReportFound: '<p>Keine Befundberichte verfügbar.</p>',
      noPersonalizationFields:
        'Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Kundensupport.',
      sendButton: 'Senden',
      downloadButton: 'Hier herunterladen'
    },
    favorites: {
      loadingMessage: 'Deine Favoritenliste wird geladen',
      empty: 'Du hast noch keine Favoriten gespeichert',
      editButton: 'Anpassen',
      finishButton: 'Anpassung beenden',
      drugs: 'Wirkstoffe/Medikamente',
      genes: 'Gene',
      actions: {
        remove: {
          label: 'Entfernen',
          errorMessage:
            'Favoriteneintrag konnte nicht entfernt werden. Versuche es später erneut.'
        }
      }
    },
    recommendation: {
      suggestionText:
        'basierend auf deiner Auswahl wurden folgende Hinweise für den Wirkstoff <span class="emphasized">‚{activeIngredient}‘</span> gefunden',
      notice:
        'Dieser Befund kann eine Entscheidung oder Beurteilung, die im persönlichen Kontakt mit einem Arzt getroffen wird, nicht ersetzen.\n Das Absetzen einer Medikation oder eine Änderung der Dosierung ohne Rücksprache mit einem Arzt kann mit Risiken verbunden sein.'
    },
    myDna: {
      noContent: 'Keine Inhalte verfügbar.',
      descriptions: {
        genes:
          'Gene mit bei dir nachgewiesenen DNA-Varianten und deren Bedeutung für Arzneimitteltherapien.',
        drugs: 'Wirkstoffe, für die persönliche Dosisempfehlungen vorliegen.',
        results: 'Alle Ergebnisse meiner Laboranalysen.'
      },
      loadingMessage: 'Daten werden geladen'
    },
    information: {
      loadingMessage: 'Daten werden geladen'
    },
    feedback: {
      openModalButton: 'Feedback senden',
      title: 'Feedback zur App',
      rating: {
        awesome: 'Unglaublich!',
        good: 'Gut',
        meh: 'Meh!',
        bad: 'Schlecht',
        horrible: 'Grauenhaft!'
      },
      rateThisPage: 'Bewerte diese Seite',
      whatDoYouLike:
        'Wenn dir diese APP gefällt, sag es weiter - gern auch uns! ',
      whatNeedsToBeImproved:
        'Lass uns wissen, wo wir uns noch verbessern können.',
      submitButton: 'Absenden',
      cancelButton: 'Schließen',
      statusError: {
        requiredFields:
          'Das Formular konnte nicht versendet werden, weil nicht alle Pflichtfelder gefüllt sind.',
        requestError: 'Fehler beim Absenden! Bitte versuche es später wieder.'
      },
      statusSuccess: 'Danke für dein Feedback!',
      requiredField: 'Pflichtfeld'
    },
    patientScopeSwitcher: {
      inputText: 'Patienten ID'
    }
  },
  nl: {
    app: {
      getAndroidApp: 'Download pharma.sensor voor Android.',
      getiOSApp: 'Download pharma.sensor voor iOS.',
      loading: 'Laden...'
    },
    logIn: {
      welcome: 'Welkom',
      passwordReset: 'Wachtwoord vergeten?',
      loginError:
        'Verkeerde gebruikersnaam of wachtwoord. Probeer het opnieuw of vraag een nieuw wachtwoord aan.',
      cookieHint:
        'Deze website gebruikt cookies om een comfortabele gebruikerservaring te ondersteunen. Voor meer informatie zie ons privacybeleid.',
      cookieHintButton: 'Ik begrijp het',
      changePasswordAfterFirstLogin:
        'Verander uw initiële wachtwoord voordat u verdergaat met de applicatie.',
      logOut: 'Uitloggen',
      or: 'of'
    },
    loginForm: {
      username: 'Gebruikersnaam',
      password: 'Wachtwoord',
      showPassword: 'Wachtwoord tonen',
      loginButton: 'Inloggen'
    },
    navbar: {
      logout: 'Uitloggen',
      settings: 'Instellingen',
      check: 'Medicijn check',
      mydna: 'Mijn DNA-analyse',
      report: 'Klinisch rapport',
      drugs: 'Werkzame stoffen',
      genes: 'Genen',
      results: 'Resultaten',
      favorites: 'Favorieten',
      help: 'Ondersteuning',
      more: 'Meer',
      userInfo: 'ingelogd als',
      patientInfo: 'geselecteerde patiënt:',
      noSelection: 'geen',
      loading: 'Laden...'
    },
    settings: {
      loading: 'Instellingen worden opgeslagen...'
    },
    passwordForm: {
      header: 'Wachtwoord wijzigen',
      currentPassword: 'Huidig wachtwoord',
      newPassword: 'Nieuw wachtwoord',
      newPasswordConfirm: 'Bevestig nieuw wachtwoord',
      confirmPasswordError:
        'De ingevoerde waarden voor het nieuwe wachtwoord moeten identiek zijn.',
      submitButton: 'Wachtwoord wijzigen',
      changeError: 'Uw huidige wachtwoord ontbreekt of is onjuist. Het is vereist om het wachtwoord te wijzigen.',
      success: 'Uw wachtwoord is succesvol gewijzigd!',
      hint: 'Om veiligheidsredenen raden we aan om uw wachtwoord te wijzigen.',
      showPassword: 'Wachtwoord tonen'
    },
    emailForm: {
      reasonHeader: 'E-mailadres invoeren',
      reason1: 'om uw wachtwoord te herstellen,\nals u het vergeet',
      reason2:
        'voor meldingen bij updates\nbijv. van aanbevelingen voor medicatietherapie',
      email: 'E-mailadres invoeren',
      emailConfirm: 'E-mailadres bevestigen',
      password: 'Wachtwoord invoeren',
      currentPassword: 'uw wachtwoord',
      submitButton: 'E-mailadres opslaan',
      error: 'Uw e-mailadres kon niet worden gewijzigd. Probeer het opnieuw.',
      success: 'E-mailadres succesvol gewijzigd!',
      confirmEmailError: 'De e-mailbevestiging is onjuist.',
      skipButton: 'Overslaan'
    },
    requestPasswordResetForm: {
      header: 'Wachtwoord reset',
      description:
        'Voer uw gebruikersnaam in en we sturen u een e-mail met verdere instructies.',
      username: 'Gebruikersnaam invoeren',
      usernameConfirmation: 'Gebruikersnaam bevestigen',
      submitButton: 'Formulier verzenden',
      cancel: 'Annuleren en terug naar login',
      error:
        'De ingevoerde gebruikersnaam is verkeerd of de gebruiker heeft geen e-mailadres toegewezen',
      success: 'Verdere instructies zijn naar uw e-mailadres verzonden',
      confirmationError:
        'De ingevoerde waarden zijn niet identiek. Probeer het opnieuw'
    },
    passwordResetForm: {
      header: 'Wachtwoord reset',
      newPassword: 'Nieuw wachtwoord invoeren',
      newPasswordConfirmation: 'Nieuw wachtwoord bevestigen',
      submitButton: 'Wachtwoord opslaan',
      success: 'Uw wachtwoord is succesvol gereset',
      confirmationError:
        'De ingevoerde waarden zijn niet identiek, probeer het opnieuw',
      error:
        'Er was een fout bij het verwerken van uw verzoek, probeer het opnieuw',
      redirect: 'Ga naar login'
    },
    languageForm: {
      header: 'Voorkeurstaal',
      error: 'Taal kon niet worden gewijzigd. Probeer het opnieuw.',
      de: 'Duits',
      en: 'Engels'
    },
    footer: {
      imprint: 'Impressum',
      terms: 'Algemene voorwaarden',
      policy: 'Privacybeleid'
    },
    search: {
      intro:
        'zoek naar medicijnen en werkzame stoffen voor persoonlijke aanbevelingen',
      inputText:
        'typ medicijnen, werkzame stoffen of ‚Pharmazentralnummer (PZN code)',
      most_common_search: 'meest voorkomende zoekopdrachten voor werkzame stoffen:',
      autocomplete_no_results: 'Geen resultaten gevonden',
      search_param: 'U zocht naar:',
      search_result_description:
        'Uw zoekopdracht leverde resultaten op voor de volgende werkzame stoffen:',
      favorite_button_add: 'Toevoegen aan favorieten',
      favorite_button_remove: 'Verwijderen uit favorieten',
      search_results_empty: 'Voor deze werkzame stof zijn er momenteel geen behandelingsaanbevelingen gebaseerd op DNA-varianten.',
      fetching: 'Zoekopdracht wordt verwerkt, even geduld...',
      legend: {
        button: 'Wat betekenen de symbolen?',
        text: {
          good: 'Uw DNA-varianten beïnvloeden het effect van deze stof niet.',
          alert:
            'Uw DNA-varianten zijn relevant voor het effect van deze stof.\n Raadpleeg de aanbevelingen.'
        },
        close: 'Sluiten'
      },
      sections: {
        recommendation: 'aanbeveling',
        gene_info: 'gen',
        background_info: 'wetenschappelijke achtergrond',
        references: 'literatuur'
      },
      no_info: 'Deze functie wordt binnenkort beschikbaar.',
      clear_search: 'Zoekopdracht wissen',
      active_ingredient_name: 'werkzame stof',
      drug_name: 'medicijn',
      gene: 'Gen',
      pzn: 'PZN'
    },
    help: {
      text: 'Vragen? Neem contact met ons op:',
      tel: 'tel',
      fax: 'fax'
    },
    searchResultItem: {
      myResult: 'mijn DNA-variant',
      viewMore: 'meer bekijken',
      viewLess: 'minder bekijken'
    },
    tutorial: {
      openModal: 'Tutorial farmacogenetica',
      title: 'Tutorial',
      closeButton: 'Annuleren',
      prev: 'Vorige',
      next: 'Volgende',
      slide1: {
        title: 'Overzicht: genen, DNA-varianten, eiwitten en medicijneffectiviteit',
        subTitle: 'Genen',
        list:
          'zijn DNA-secties die de blauwdruk bevatten voor het maken van eiwitten'
      },
      slide2: {
        title: 'Hoe een medicijn door ons lichaam reist',
        list:
          'bepaalde eiwitten zijn belangrijk voor medicijnen om effectief te zijn'
      },
      slide3: {
        title: 'DNA-varianten',
        list:
          'individuele DNA-varianten in genen beïnvloeden de functie van deze eiwitten'
      },
      slide4: {
        title: 'Effecten van DNA-varianten op medicijnen',
        list:
          'daarom kan de effectiviteit van medicijnen verschillend zijn voor elke persoon\nze kunnen toxisch zijn, te sterk, of helemaal niet werken'
      }
    },
    report: {
      personalizeButton: 'Rapport maken',
      reportInfo: `
      <p>Vul het openingsformulier in met uw persoonlijke informatie voordat u print. Hierdoor kan een arts de beschikbare aanbevelingen gebruiken voor een klinische beslissing.</p>
      <p>
      Het rapport is uitsluitend bedoeld voor de persoon wiens analyseresultaten in dit gebruikersaccount worden getoond.
      </p>`,
      reportIsGenerating: `Uw rapport wordt gegenereerd en zal binnenkort beschikbaar zijn.
      Let op dat de PDF 30 seconden beschikbaar is voor download.
      Daarna worden het document en uw persoonlijke gegevens vernietigd.`,
      noReportFound: '<p>Er zijn geen rapporten beschikbaar</p>',
      noPersonalizationFields:
        'Er is een fout opgetreden. Neem contact op met de klantenservice.',
      printJobStatusPending: 'Rapport wordt gemaakt...',
      printJobStatusReady: 'Rapport succesvol gemaakt.',
      printJobStatusError:
        'Fout bij het maken van rapport. Probeer het later opnieuw.',
      printJobStatusExpired: `Time-out tijdens orderverwerking. Voor bescherming van gegevensprivacy
        worden gepersonaliseerde rapporten na 30 seconden verwijderd. Genereer een nieuw rapport.`,
      sendButton: 'Verzenden',
      downloadButton: 'Download hier'
    },
    favorites: {
      loadingMessage: 'Uw favorietenlijst wordt geladen',
      empty: "U heeft nog geen favorieten opgeslagen",
      editButton: 'Bewerken',
      finishButton: 'Bewerken voltooien',
      drugs: 'Werkzame stoffen / medicamenten',
      genes: 'Genen',
      actions: {
        remove: {
          label: 'Verwijderen',
          errorMessage: 'Favoriet kon niet worden verwijderd, probeer het later opnieuw.'
        }
      }
    },
    recommendation: {
      suggestionText:
        'gebaseerd op uw zoekopdracht, werd de volgende informatie voor de werkzame stof ‚<span class="emphasized">{activeIngredient}</span> gevonden',
      notice:
        'Dit rapport vervangt geen beslissing die in samenwerking met een arts of genetisch counselor wordt genomen.\n Om ernstige gezondheidsrisico\'s te vermijden, moet verandering van medicatietherapie alleen onder medisch toezicht gebeuren.'
    },
    myDna: {
      noContent: 'Geen inhoud beschikbaar.',
      descriptions: {
        genes:
          'Genen waarin persoonlijke DNA-varianten werden gevonden en hun rol in medicatietherapieën.',
        drugs: 'Werkzame stoffen met persoonlijke dosisaanbevelingen.',
        results: 'Alle resultaten van mijn laboratoriumanalyse.'
      },
      loadingMessage: 'Gegevens worden geladen'
    },
    information: {
      loadingMessage: 'Gegevens worden geladen'
    },
    feedback: {
      openModalButton: 'Stuur ons feedback',
      title: 'Feedback over de app',
      rating: {
        awesome: 'Geweldig!',
        good: 'Goed',
        meh: 'Meh!',
        bad: 'Slecht',
        horrible: 'Verschrikkelijk!'
      },
      rateThisPage: 'Beoordeel deze pagina',
      whatDoYouLike: 'Wat vindt u leuk?',
      whatNeedsToBeImproved: 'Wat moet worden verbeterd?',
      submitButton: 'Verzenden',
      cancelButton: 'Sluiten',
      statusError: {
        requiredFields:
          'Het formulier kon niet worden verzonden omdat enkele verplichte velden ontbreken.',
        requestError: 'Er is een fout opgetreden! Probeer het later opnieuw.'
      },
      statusSuccess: 'Bedankt voor uw feedback!',
      requiredField: 'Verplicht veld'
    },
    patientScopeSwitcher: {
      inputText: 'Patiënt ID'
    }
  }
};
